import {
  SubmissionCoordinates,
  getDeadlinePartialDeadline
} from "@cs124/questioner";
import assert from "assert";
import { Boolean, InstanceOf, Literal, Number, Partial, Record, String } from "runtypes";
import { Languages } from "./languages";
export const Metadata = Record({
  type: Literal("metadata"),
  number: String,
  semester: String,
  path: String,
  sitePath: String,
  language: Languages,
  contentType: Literal("walkthrough").Or(Literal("video")),
  instructions: String,
  open: Boolean,
  disabled: Boolean
}).And(
  Partial({
    available: InstanceOf(Date).Or(String.withConstraint((s) => !isNaN(Date.parse(s)))),
    code: String,
    loginRequired: Boolean,
    lesson: Record({
      name: String,
      number: Number
    })
  })
);
export function validateMetadata(metadata) {
  if (!metadata.open) {
    assert(metadata.available);
    assert(metadata.loginRequired !== void 0);
    assert(metadata.lesson);
  }
  if (metadata.contentType === "walkthrough") {
    assert(metadata.code !== void 0);
  }
  if (metadata.language === "any") {
    assert(metadata.contentType === "video");
  }
}
export function pathFromQuestionerCoordinates(coordinates) {
  return `jsp/${coordinates.submissionType.toLowerCase()}/${coordinates.language}/${coordinates.path}/${coordinates.author}`;
}
export function pathIsJSP(path) {
  if (!path) {
    return false;
  }
  const flatCoordinates = path.replace(/^jsp\//, "").split("/");
  return SubmissionCoordinates.guard({
    submissionType: flatCoordinates[0].toUpperCase(),
    language: flatCoordinates[1],
    path: flatCoordinates[2],
    author: flatCoordinates[3]
  });
}
export function coordinatesFromShareablePath(path) {
  const flatCoordinates = path.replace(/^jsp\//, "").split("/");
  return SubmissionCoordinates.check({
    submissionType: flatCoordinates[0].toUpperCase(),
    language: flatCoordinates[1],
    path: flatCoordinates[2],
    author: flatCoordinates[3]
  });
}
export function metadataFromQuestionerDeadline(deadline, code, sitePath) {
  return Metadata.check({
    type: "metadata",
    number: deadline.course.number,
    semester: deadline.course.semester,
    available: new Date(deadline.practice ? deadline.start : getDeadlinePartialDeadline(deadline)).toISOString(),
    path: pathFromQuestionerCoordinates(deadline.question),
    sitePath,
    language: deadline.question.language,
    contentType: "walkthrough",
    code: Buffer.from(code).toString("base64"),
    instructions: "Demonstrate how to solve the homework problem",
    loginRequired: true,
    open: false,
    disabled: false,
    ...deadline.lesson && { lesson: { name: deadline.lesson.name, number: deadline.lesson.number } }
  });
}
//# sourceMappingURL=metadata.js.map
